module.exports = __webpack_public_path__ + "img/chapter-1-thumb.a8568a89.jpg";